import React from "react";
 
const FormRadio = ({
  name,
  label,
  value,
  options = [],
  onChange,
  error,
  required = false,
  disabled = false,
  ...otherProps
}) => {
  return (
    <div className="form-row">
      {label && (
        <label className="label-one m-0">
          {label}
          {required && <span style={{ color: "#dc2626" }}> *</span>}
        </label>
      )}
 
      <div className="radio-group">
        {options.map((option, index) => {
          const optionValue =
            typeof option === "string" ? option : option.value;
          const optionLabel =
            typeof option === "string" ? option : option.label;
 
          const radioId = `${name}-${index}`;
 
          return (
            <label htmlFor={radioId} className={`radio-item ${value === optionValue ? "selected" : ""}`} key={radioId} >
              <input
                type="radio"
                id={radioId}
                name={name}
                value={optionValue}
                checked={value === optionValue}
                onChange={onChange}
                required={required}
                disabled={disabled}
                {...otherProps}
              />
              {optionLabel}
            </label>
          );
        })}
      </div>
 
      {error && <div className="error-text">{error}</div>}
    </div>
  );
};
 
export default FormRadio;